import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/services/api.service';
import { DateService } from '../../../shared/services/date.service';
import { ImageService } from '../../../shared/services/image.service';
import { AuthService } from '../../../shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  standalone: false,
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit {

  customerId: string = '';
  selectedCustomer: any = null;
  customerData: any = null;
  beneficiaries: any[] = [];
  isLoading = true;
  comment: any;
  intelliWingsResponse: any;



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _api: ApiService,
    private _date: DateService,
    private _imageService: ImageService,
    public _auth: AuthService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.customerId = params['id'];
      if (this.customerId) {
        this.loadCustomer();
      }
    });
  }

  loadCustomer() {
    const vm = this;
    vm.isLoading = true;
    const user = vm._auth.getUser();
    vm._api.getData('/partners/auth/customers?_page=1&_limit=500').subscribe((res: any) => {
      if (res && !res.error && res.data) {
        vm.selectedCustomer = res.data.find((c: any) => c.customerId._id === vm.customerId) || null;
      }
      vm.getCustomerDetails();
    });
  }

  getCustomerDetails() {
    const vm = this;
    vm._api.getData('/partners/auth/profile/' + vm.customerId + '?_t=' + Date.now()).subscribe((res: any) => {
      vm.isLoading = false;
      if (res && !res.error) {
        vm.customerData = res.data;
        if (!vm.selectedCustomer && vm.customerData) {
          vm.selectedCustomer = vm.customerData;
        }
      }
    }, () => {
      vm.isLoading = false;
    });
    vm.loadBeneficiaries();
  }

  loadBeneficiaries() {
    const vm = this;
    vm._api.getData('/partners/auth/customers/' + vm.customerId + '/beneficiaries').subscribe((res: any) => {
      if (res && !res.error) {
        vm.beneficiaries = Array.isArray(res.data) ? res.data : [];
      }
    });
  }

  getBeneficiaryDetailKeys(detailsObject: any): string[] {
    if (!detailsObject) return [];
    return Object.keys(detailsObject).filter(k => k !== 'bankId' && k !== 'countryId' && k !== 'logoUrl');
  }

  getFirstFieldValue(obj: any): string {
    if (!obj) return '';
    const keys = Object.keys(obj);
    return keys.length ? obj[keys[0]] : '';
  }

  getDynamicFieldKeys(dynamicFields: any): string[] {
    if (!dynamicFields) return [];
    const excludeKeys = ['Transaction Type', 'Bank NameImageUrl', 'Beneficiary Account Number', 'Account Number', 'Mobile Number', 'Beneficiary Name'];
    return Object.keys(dynamicFields).filter(k => !excludeKeys.includes(k));
  }

  goBack() {
    this.router.navigate(['/app/customers']);
  }

  refreshComments() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { _t: Date.now() },
      queryParamsHandling: 'merge'
    });
  }

  viewBeneficiaryTransactions(beneficiary: any) {
    this.router.navigate(['/app/customers/beneficiary-transactions'], {
      queryParams: {
        customerId: this.customerId,
        beneficiaryId: beneficiary._id
      }
    });
  }

  dateFormat(value: any) {
    return this._date.getDDMMYYYYfromEPOC(value);
  }

  formatDob(dob: number, format?: string): string {
    if (!dob) return '—';
    const date = new Date(dob);
    if (isNaN(date.getTime())) return '—';
    let d = String(date.getDate()).padStart(2, '0');
    let m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear().toString();
    const fmt = format || 'DD-MM-YYYY';
    if (fmt === 'MM-DD-YYYY') return `${m}/${d}/${y}`;
    if (fmt === 'YYYY-MM-DD') return `${y}/${m}/${d}`;
    return `${d}/${m}/${y}`;
  }

  getImage(id: any) {
    if (id && id.startsWith('http')) {
      id = new URL(id).pathname.split('/').pop();
    }
    this._imageService.fetchAndViewDoc(id);
  }

  formatMobile(mobile: string): string {
    if (!mobile) return '';

    const cleanMobile = mobile.replace(/[\s-]/g, '');
    const dialingCode = this.selectedCustomer?.country?.dialingCode || this.selectedCustomer?.customerId?.country?.dialingCode;

    if (dialingCode) {
      const numberPart = cleanMobile.replace(dialingCode, '');
      if (numberPart && numberPart !== cleanMobile) {
        return `${dialingCode} ${numberPart}`;
      }
    }

    if (cleanMobile.startsWith('+91')) {
      return '+91 ' + cleanMobile.slice(3);
    } else {
      const countryCodeMatch = cleanMobile.match(/^(\+\d{1,3})(.*)$/);
      if (countryCodeMatch && countryCodeMatch[2]) {
        return `${countryCodeMatch[1]} ${countryCodeMatch[2]}`;
      }
    }

    return mobile;
  }

  formatBeneficiaryMobile(mobile: string, beneficiary: any): string {
    if (!mobile) return '';

    const cleanMobile = mobile.replace(/[\s-]/g, '');
    const dialingCode = beneficiary?.country?.dialingCode;

    if (dialingCode) {
      const numberPart = cleanMobile.replace(dialingCode, '');
      if (numberPart && numberPart !== cleanMobile) {
        return `${dialingCode} ${numberPart}`;
      }
    }

    if (cleanMobile.startsWith('+91')) {
      return '+91 ' + cleanMobile.slice(3);
    } else {
      const countryCodeMatch = cleanMobile.match(/^(\+\d{1,3})(.*)$/);
      if (countryCodeMatch && countryCodeMatch[2]) {
        return `${countryCodeMatch[1]} ${countryCodeMatch[2]}`;
      }
    }

    return mobile;
  }

  getCustomer() {
    return this.selectedCustomer?.customerId || this.selectedCustomer;
  }


  onCustomerUpdateStatus(status) {
    const vm = this;
    if (status === 'In-Progress' && (!vm.comment || vm.comment.trim() === '')) {
      alert('Comment is mandatory for In-Progress');
      return;
    }
    if (status === 'Rejected' && (!vm.comment || vm.comment.trim() === '')) {
      alert('Comment is mandatory for Reject');
      return;
    }
    const user = vm._auth.getUser();
    if (vm.comment && vm.comment.trim() !== '') {
      if (!vm.customerData.customer.comments) {
        vm.customerData.customer.comments = [];
      }
      vm.customerData.customer.comments.push({
        comment: vm.comment,
        userId: user._id,
        date: Date.now(),
        userName: user.username,
        role: user.role,
        email: user.email,
        phone: user.phone
      });
      vm.comment = '';
    }
    vm.customerData.customer.customerStatus = status;
    vm.updateAuditLog(status);
    const reqObj = {};
    reqObj['_id'] = vm.customerData.customer._id;
    reqObj['customerStatus'] = vm.customerData.customer.customerStatus;
    reqObj['comments'] = vm.customerData.customer.comments;
    reqObj['auditLog'] = vm.customerData.customer.auditLog;
    vm._api.postData('/partners/auth/updateCustomerProfile', reqObj).subscribe((res: any) => {
      if (res && !res.error) {
      }
    });
  }

  updateAuditLog(status) {
    const vm = this;
    const user = vm._auth.getUser();
    if (!vm.customerData.customer.auditLog) {
      vm.customerData.customer.auditLog = [];
    }
    vm.customerData.customer.auditLog.push({
      actionBy: user._id,
      action: status,
      actionDate: Date.now(),
      userName: user.username,
      role: user.role,
      email: user.email,
      phone: user.phone
    });
  }

  verifyWithIntelliWings() {
    const vm = this;
    const requestData = {
      firstName: vm.customerData?.customer?.name,
      lastName: "",
      type: "Individual",
      source: "SourceName",
      id: vm.customerData?.kyc?.passportNumber, // "0090901"
      dob: vm.customerData?.customer?.dob, // 631152000000
    };
    vm.intelliWingsResponse = null;
    vm._api.postData('/common/scan-prospect-intellewings', requestData).subscribe((res: any) => {
      if (res && !res.error) {
        vm.intelliWingsResponse = res.data;
      }
    });
  }
}
